// #region import
import Vue from 'vue'
import App from './App.vue'
import router from '@/plugins/router'
import store from '@/plugins/store'
// #endregion

// #region VueMeta
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
// #endregion

// #region BootstrapVue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import './assets/scss/app.scss'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
// #endregion

// #region Lottie
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue'
Vue.use(LottieAnimation)
// #endregion

// #region i18n
import i18n from './plugins/i18n'
// #endregion

// #region config
Vue.config.productionTip = false
// #endregion

// #region init
store.dispatch('initializeStore').then(() => {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app')
})
  .catch(console.log)
// #endregion
